import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { GeofenceService } from '../services/geofence.service';
import { UserService } from '../services/user.service';
import { AddressService } from '../services/address.service';
import { Message } from 'primeng/primeng';
import { Table } from 'primeng/table';
import * as XLSX from 'xlsx';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-geofence-report',
  templateUrl: './geofence-report.component.html'
})
export class GeofenceReportComponent implements OnInit {
  fileName: String;
  events: any[];
  devices: SelectItem[];
  geofences: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  idDevice: String;
  idGeofence: number;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  entradasCount: number = 0;
  salidasCount: number = 0;
  blockedDocument: boolean = false;
  cols: any[];
  maxDays: number = 35;

  @ViewChild('dt') table: Table;

  constructor(
    private positionService: PositionService,
    private deviceService: DeviceService,
    private geofenceService: GeofenceService,
    private userService: UserService,
    private addressService: AddressService
  ) { }

  ngOnInit() {
    this.cols = [
      { field: 'vehicleName', header: 'NOMBRE' },
      { field: 'dateTime', header: 'FECHA/HORA' },
      { field: 'position', header: 'POSICION' },
      { field: 'detail', header: 'DETALLE' },
      { field: 'speed', header: 'VELOCIDAD' },
      { field: 'address', header: 'DIRECCION' }
    ];
    this.dateOptions = [
      {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
      {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
      {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
      {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
    ];

    this.devices = [];
    this.devices.push({label: 'Todos los Equipos', value: null});
    this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push({label: item.name, value: item.idDevice});
      });
    }).catch(err => {
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Error al cargar vehículos"}];
    });

    this.geofences = [];
    this.geofences.push({label: 'Todas las Geocercas', value: null});
    this.geofenceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.geofences.forEach(item => {
        this.geofences.push({label: item.name, value: item.idGeofence});
      });
    }).catch(err => {
      console.log(err);
    });

    this.dateOption = 'T';
    this.changeDate();
  }

  changeDate() {
    this.disabledInitialDate = true;
    this.disabledFinalDate = true;
    let dateTime = new Date();
    if(this.dateOption == 'T'){
      this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
      this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
    }else if(this.dateOption == 'Y'){
      this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 0, 0, 0));
      this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 23, 59, 59));
    }else if(this.dateOption == '7'){
      this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 6, 0, 0, 0));
      this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
    }else{
      this.disabledInitialDate = false;
      this.disabledFinalDate = false;
    }
  }

  diferenciaEntreFechasEnDias(a:Date, b:Date):number {
    return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
  }

  buscar() {
    if(this.table) {
      this.table.first = 1;
    }
    this.fileName = "Geocercas_";
    if (this.idDevice) {
      this.devices.forEach(item => {
        if(item.value == this.idDevice) {
          this.fileName = this.fileName + item.label;
        }
      });
    } else if (this.idGeofence) {
      this.geofences.forEach(item => {
        if(item.value == this.idGeofence) {
          this.fileName = this.fileName + item.label;
        }
      });
    }

    if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays) {
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
      return;
    }
    if(this.initialDate >= this.finalDate) {
      this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
      return;
    }

    this.blockedDocument = true;
    this.events = [];
    this.positionService.findGeofenceEvents(this.idDevice, this.idGeofence, this.initialDate, this.finalDate, this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      if (response.status === 'OK') {
         this.events = response.events;
         this.entradasCount = 0;
         this.salidasCount = 0;
         for (let e of this.events) {
           if (e.position) {
             let coords = e.position.split(',');
             if (coords.length === 2) {
               let lat = parseFloat(coords[0].trim());
               let lng = parseFloat(coords[1].trim());
               if (!isNaN(lat) && !isNaN(lng)) {
                 e.position = lat.toFixed(6) + ', ' + lng.toFixed(6);
               }
             }
           }
           if (e.speed !== null && e.speed !== undefined) {
             let speedNum = typeof e.speed === 'number' ? e.speed : parseFloat(e.speed);
             if (!isNaN(speedNum)) {
               e.speed = speedNum.toFixed(2);
             }
           }
           if (e.detail && e.detail.startsWith("Entrada")) {
             this.entradasCount++;
           } else if (e.detail && e.detail.startsWith("Salida")) {
             this.salidasCount++;
           }
         }
      } else {
         this.msgs = [{severity:'error', summary:'ERROR', detail: response.message}];
      }
      this.blockedDocument = false;
    }).catch(err => {
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }


  exportXLS() {
    let records = [];
    this.events.forEach(item => {
      let data = {};
      this.cols.forEach(col => {
        data[col.header] = item[col.field];
      });
      records.push(data);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.fileName + ".xlsx");
  }

  exportPDF(){
    let url = environment.reportsEndPoint + "viewGeofenceReport?startDate=" + this.initialDate.toISOString() + "&endDate=" + this.finalDate.toISOString();
    url += "&idUser=" + this.userService.userLoged.idUser;
    if (this.idDevice) {
      url += "&idDevice=" + this.idDevice;
    }
    if (this.idGeofence) {
      url += "&idGeofence=" + this.idGeofence;
    }
    window.open(url, "_blank");
  }

  getAddress(item: any) {
    let parts = item.position.split(',');
    let lat = 0;
    let lng = 0;
    if (parts.length >= 2) {
      lat = parseFloat(parts[0].trim());
      lng = parseFloat(parts[1].trim());
    }
    let req = {
      latitude: lat,
      longitude: lng,
      idDevice: item.idDevice, 
      deviceTime: item.dateTime 
    };

    this.blockedDocument = true;
    this.addressService.findAddressByCoordinates(req).then(data => {
      let response: any = data;
      if (response.status == 'OK') {
        item.address = response.address;
        this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
      } else {
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err => {
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/geofence-report/geofence-report.component.ts